var React = require('react');

function XBig (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon_X_big","data-name":"icon / X big","transform":"translate(0)"},React.createElement("g",{"id":"Group_15891","data-name":"Group 15891","transform":"translate(-52 -30.36)"},React.createElement("path",{"id":"Union_5","data-name":"Union 5","d":"M3634.991,6865.765l-27.577,27.577-1.415-1.415,27.577-27.577L3606,6836.773l1.415-1.413,27.577,27.577,27.578-27.577,1.413,1.413-27.577,27.578,27.577,27.577-1.413,1.415Z","transform":"translate(-3554 -6805)","fill":"#0f0f0f"}))));
}

XBig.defaultProps = {"width":"57.983","height":"57.982","viewBox":"0 0 57.983 57.982"};

module.exports = XBig;

XBig.default = XBig;
